import React from "react";
import { ChevronLeft, ChevronRight, MessageSquarePlus, X } from "lucide-react";
import { useAgent } from "../../contexts/AgentContext";
import { AgentSelectionDialog } from "../agents/AgentSelectionDialog";
import { AnimatedAvatar } from "../agents/AnimatedAvatar";

interface NavigationControlsProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  onNewChat: () => void;
  hasNewChat: boolean;
}

export const NavigationControls: React.FC<NavigationControlsProps> = ({
  sidebarOpen,
  toggleSidebar,
  onNewChat,
  hasNewChat,
}) => {
  const { mainAgent, selectedAgents, removeAgent, isDialogOpen, openDialog, closeDialog } = useAgent();

  return (
    <div className="flex items-center space-x-3">
      <button
        className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-gray-700 dark:text-gray-300"
        onClick={toggleSidebar}
      >
        {sidebarOpen ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
      </button>
      {!sidebarOpen && (
        <button
          onClick={onNewChat}
          disabled={hasNewChat}
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-gray-700 dark:text-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
          title="New Convo"
        >
          <MessageSquarePlus size={20} />
        </button>
      )}
      
      {/* Main Agent - Clickable to open dialog */}
      <div 
        className="flex items-center cursor-pointer hover:opacity-80 transition-opacity duration-200"
        onClick={openDialog}
      >
        <AnimatedAvatar 
          src={mainAgent.avatar}
          alt={`${mainAgent.name} Logo`}
          size="md"
          enabled={mainAgent.enabled}
        />
        <h1 className="ml-3 text-lg font-semibold text-gray-900 dark:text-white hidden sm:block">
          {mainAgent.name}
        </h1>
      </div>
      
      {/* Selected Agents with Remove Badge */}
      <div className="flex items-center space-x-2">
        {selectedAgents.map((agent) => (
          <div key={agent.id} className="relative">
            <AnimatedAvatar 
              src={agent.avatar}
              alt={`${agent.name} Logo`}
              size="md"
              enabled={agent.enabled}
              disableHoverEffect={true}
            />
            {/* Remove Badge */}
            <button
              className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center hover:bg-red-600 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                removeAgent(agent.id);
              }}
              title={`Remove ${agent.name}`}
            >
              <X size={12} />
            </button>
          </div>
        ))}
      </div>

      <AgentSelectionDialog
        isOpen={isDialogOpen}
        onClose={closeDialog}
      />
    </div>
  );
};
